(function () {
  'use strict';

  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      alert: {
        information: "Information",
        areYouSure: "Are you sure?",
        blockCardInfo: "Do you really want to block your card ?",
        blockCardCost: "It will cost you",
        blockCard: "Block card",
        payment: "Payment order",
        template: "Template order",
        termDeposit: "Term deposit",
        investment: "Investment order",
        subscriptionRequest: "You have successfully entered a request for subscription",
        successSign: "You have successfully signed payment",
        successSignSlo: "Your order has been submitted successfully.",
        closeEBook: "You have successfully closed e-book",
        cancelRegistration: "You have successfully canceled registration",
        ebookOrder: "eSaving book order",
        archiveEInvoice: "You have successfully archived e-invoice",
        saveTemplate: "You have successfully saved template",
        updateTemplate: "You have successfully updated template",
        deleteAction: "Deletion",
        cancel: "Close",
        yes: "Yes",
        no: "No",
        success: "Success!",
        qrCode: "Generated QRCode",
        paymentsReturnText: 'There are unanswered massages in the "Payments - Payments return".'
      }
    };

    $translateProvider
        .translations('en', data);

  }
}());
